import React from 'react';

import { Edit as EditIcon, Code as CodeIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import MessageWrapper from 'pages/Analysis/components/MessageWrapper';
import type { EditBusinessUnitPromptToolArguments } from 'services/types/ticket';

import TextEdit from './TextEdit';

interface Props {
  args: string;
}

const EditPromptToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: EditBusinessUnitPromptToolArguments;

  try {
    parsedArgs = JSON.parse(args) as EditBusinessUnitPromptToolArguments;
  } catch (error) {
    return (
      <MessageWrapper caption="Herramienta de Edición" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Editar unidad de negocio" align="left">
      <Box>
        <Box mb={1}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <EditIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Business Unit:
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'monospace', bgcolor: 'grey.100', p: 1, borderRadius: 1 }}>
            {parsedArgs.businessUnitId}
          </Typography>
        </Box>

        <Box mb={1}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <CodeIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Modificaciones:
          </Typography>
          <Box sx={{ maxHeight: '300px', overflow: 'auto' }}>
            <TextEdit codeEdit={parsedArgs.promptEdits || ''} />
          </Box>
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default EditPromptToolComponent;
